import { http } from '@/api/http'
import { toListParams, type ListQuery } from '@/api/query'
import type {
  ListResponse,
  ProcurementDebt,
  ProcurementDebtFilterOptions,
  ProcurementDebtSummary,
} from '@/types/api'
import { i18n } from '@/i18n'
import type { RequestOptions } from '../crud'
import { reportLanguage } from './reports.service'

const base = '/procurement/debts'
/** Articles and reversal reasons come back in the interface language. */
const lang = () => reportLanguage(i18n.locale)

export const procurementDebtsService = {
  path: 'procurement/debts',
  async list(query?: ListQuery, options?: RequestOptions) {
    const { data } = await http.get<ListResponse<ProcurementDebt>>(base, {
      params: { ...toListParams(query), lang: lang() },
      ...options,
    })
    return { count: data.count ?? 0, items: data.items ?? [] }
  },
  async get(id: string, options?: RequestOptions) {
    const { data } = await http.get<ProcurementDebt>(`${base}/${encodeURIComponent(id)}`, { params: { lang: lang() }, ...options })
    return data
  },
  async history(id: string, options?: RequestOptions) {
    const { data } = await http.get<ProcurementDebt[]>(`${base}/${encodeURIComponent(id)}/history`, { params: { lang: lang() }, ...options })
    return data ?? []
  },
  async filterOptions(options?: RequestOptions) {
    const { data } = await http.get<ProcurementDebtFilterOptions>(`${base}/filter-options`, options)
    return data
  },
  async summaries(query: ListQuery, options?: RequestOptions) {
    const { data } = await http.get<ProcurementDebtSummary[]>(`${base}/summaries`, {
      params: toListParams({ search: query.search, filters: query.filters }),
      ...options,
    })
    return data ?? []
  },
  async export(query: ListQuery) {
    const { data } = await http.post<Blob>(
      `${base}/export`,
      { search: query.search ?? '', filters: query.filters ?? [], sort: query.sort ?? [], lang: lang() },
      { responseType: 'blob' },
    )
    return data
  },
}
